import { useEffect, useMemo, useState } from "react";
import { addDays, parseISO } from "date-fns";
import { api } from "@/lib/api";

export const useAvailability = (propertyId, refreshKey = 0) => {
  const [booked, setBooked] = useState([]);

  useEffect(() => {
    if (!propertyId) return;
    api
      .get(`/properties/${propertyId}/availability`)
      .then(({ data }) => setBooked(data.booked))
      .catch(() => {});
  }, [propertyId, refreshKey]);

  const bookedMatchers = useMemo(
    () => booked.map((r) => ({ from: parseISO(r.check_in), to: addDays(parseISO(r.check_out), -1) })),
    [booked]
  );

  return { booked, bookedMatchers };
};
